export function getSignatureImageUrl(sale: any): string {
  try {
    const assinatura = sale && sale.imagens && sale.imagens.assinatura;
    return (assinatura && assinatura.url) || '';
  } catch (e) {
    return '';
  }
}

export function getSignatureUrl(saleRecord: any): string {
  try {
    if (!saleRecord || !saleRecord.meta) return '';

    if (saleRecord.status === 'signed' && saleRecord.provider !== 'clicksign') {
      const destinatarios = saleRecord.meta.providerResult
        && saleRecord.meta.providerResult.raw
        && saleRecord.meta.providerResult.raw.destinatarios;
      const linkProcesso = destinatarios && destinatarios[0] && destinatarios[0].linkProcesso;
      if (linkProcesso) return linkProcesso;
    }

    const providerPayload = saleRecord.meta.providerPayload;
    return (providerPayload && providerPayload.documentUrl) || '';
  } catch (e) {
    return '';
  }
}

export function getSignatureStatus(saleRecord: any): string {
  return saleRecord && saleRecord.status || '';
}
